// Libraries
import React from 'react';
import PropTypes from 'prop-types';
import styled, { keyframes } from 'styled-components';

// Components
import NavigationLink from './navigation-link';
import ExternalLink from './external-link';
import ProfileUserAvatar from './user-avatar';
import IsAuthenticated from '~/components/general/restricted/is-authenticated/index';
import IsAdmin from '~/components/general/restricted/is-admin/index';
import {
	INDEX_URL,
	CHALLENGES_URL,
	MY_PROFILE_URL,
	LOGIN_URL,
	ADMIN_CHALLENGES,BLOG_URL,
	FAQS_URL
	// ADMIN_DONATIONS_AND_REWARDS,
	// ADMIN_PLAYERS,
} from '~/data/constants/router-constants';

// Constants
/**
 *  Large Navigation Menu
 *
 * @component LargeNavigation
 */
const PageNavigation = props => {
	return (
		<Wrapper id="page-navigation">
			<List>
				<NavigationLink exact={true} button={false} to={INDEX_URL} title="The Initiative" />
				<IsAdmin
					isTrue={<NavigationLink exact={true} button={false} to={ADMIN_CHALLENGES} title="Manage Challenges" />}
					isFalse={null}
				/>
				<IsAdmin
					//isTrue={<NavigationLink button={false} exact={true} to={ADMIN_DONATIONS_AND_REWARDS} title="Donations" />}
					isTrue={null}
					isFalse={<NavigationLink exact={false} button={false} to={CHALLENGES_URL} title="Challenges" />}
				/>
				<NavigationLink exact={false} button={false} to={BLOG_URL} title="Blog" />
				<NavigationLink exact={false} button={false} to={FAQS_URL} title="FAQs" />

				{/* <IsAdmin
					isTrue={<NavigationLink button={false} exact={true} to={ADMIN_PLAYERS} title="Players" />}
					isFalse={null}
				/> */}

				<IsAuthenticated
					isTrue={
						<ProfileUserAvatar
							exact={false}
							button
							photoUrl={props.photoUrl}
							hasIconAlert={props.avatarHasIconAlert}
							to={MY_PROFILE_URL}
							title="Profile"
						/>
					}
					isFalse={<NavigationLink button exact={false} to={LOGIN_URL} title="Sign In" />}
				/>
			</List>
		</Wrapper>
	);
};

// Styled Components
const fadeIn = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }keyframes
`;

const Wrapper = styled.nav`
	display: flex;
	flex-direction: row;
	justify-content: space-around;
	align-items: center;
	max-height: ${props => props.theme.navbarHeight};
	width: 100%;

	animation-name: ${fadeIn};
	animation-duration: 1000ms;
	animation-timing-function: ${props => props.theme.easeOutCirc};
	animation-delay: 1000ms;
	animation-fill-mode: forwards;
	opacity: 0;
`;

const List = styled.ul`
	justify-content: center;
	align-items: center;
	flex-direction: row;
	font-family: ${props => props.theme.bodyFontFamily};
	height: ${props => props.theme.navbarHeight};
	margin: 0 auto;
	width: 100%;
	display: none;
	visibility: hidden;

	@media ${props => props.theme.breakpointLarge} {
		display: block;
		display: flex;
		visibility: visible;
	}
`;

PageNavigation.propTypes = {
	photoUrl: PropTypes.string,
	avatarHasIconAlert: PropTypes.bool,
};

export default PageNavigation;



// WEBPACK FOOTER //
// ./src/components/ui/navigation/header/page-navigation.jsx